import React from 'react'
import Grid from '@mui/material/Grid'
import Tooltip from '@mui/material/Tooltip'
import { useTranslation } from 'react-i18next'

import { WholesalerType } from 'shared/store/useWholesalers/types'

import { Close, Edit } from '@mui/icons-material'
import { StyledCard, EditCorner, StyledImg, RejectedCorner } from './styles'
import { WholesalerActionType } from '../../types'

type Props = {
   activeWholesaler: WholesalerType
   handleWholesaler: (wholesalerId: string, type: WholesalerActionType) => void
}

export default function RejectedWholesalerCard({ activeWholesaler, handleWholesaler }: Props) {
   const { t } = useTranslation('WHOLESALERS')

   return (
      <Grid size={{ xs: 6, sm: 4, md: 4, lg: 3, xl: 2 }}>
         <Tooltip title={t('wholesaleRejectedTooltip') || ''}>
            <StyledCard>
               <RejectedCorner>
                  <Close sx={{ color: 'red', mt: '3px', ml: '4px' }} />
               </RejectedCorner>
               <EditCorner onClick={() => handleWholesaler(activeWholesaler.wholesaleUuid, 'addWholesaler')}>
                  <Edit />
               </EditCorner>
               <StyledImg
                  src={`${process.env.REACT_APP_FILES_URL}/img/logos-wholesalers/light/${activeWholesaler.wholesaleUuid}.png`}
                  alt={activeWholesaler.wholesaleName}
               />
            </StyledCard>
         </Tooltip>
      </Grid>
   )
}
